import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getProcessDefinitions(queryString) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/process-engine/process-definitions-api/deployed-processes?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching applications"
                    });
                }
            });
    },
    getCategories() {
        return axios.get(constants.BASE_URL + "/categories/all", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    updateCategory(processId, selectedCat) {
        axios.defaults.withCredentials = true;
        return axios.put(constants.BASE_URL + "/process-engine/process-definitions-api/" + processId + "/update-category?selectedCategory=" + selectedCat).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('warning-notification', {
                "msg": "Could not process your request."
            });
        });
    },
    getAllUsers() {
        return axios.get(constants.BASE_URL + "/process-engine/process-definitions-api/all-users", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getUsers(defId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/process-engine/process-definitions-api/users?processDefinitionId=" + defId)
            .then(response => {
                return response.data;
            });
    },
    getGroups(defId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/process-engine/process-definitions-api/groups?processDefinitionId=" + defId)
            .then(response => {
                return response.data;
            });
    },
    addNewUser(procId, username) {
        return axios.post(constants.BASE_URL + "/process-engine/process-definitions-api/" + procId + "/add-user?username=" + encodeURI(username), {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    addNewGroup(procId, group) {
        return axios.post(constants.BASE_URL + "/process-engine/process-definitions-api/" + procId + "/add-group?group=" + group, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    removeUser(procId, username) {
        return axios.delete(constants.BASE_URL + "/process-engine/process-definitions-api/" + procId + "/remove-user?username=" + encodeURI(username), {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    removeGroup(procId, group) {
        return axios.delete(constants.BASE_URL + "/process-engine/process-definitions-api/" + procId + "/remove-group?group=" + group, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getDefinitionDetails(defId) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/process-engine/process-definitions-api/" + defId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
            });
    },
    suspendProcess(requestBody, processId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/process-engine/process-definitions-api/" + processId + "/suspend", requestBody).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('warning-notification', {
                "msg": "Could not process your request."
            });
        });
    },
    activateProcess(requestBody, processId) {
        axios.defaults.withCredentials = true;
        return axios.post(constants.BASE_URL + "/process-engine/process-definitions-api/" + processId + "/activate", requestBody).then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('warning-notification', {
                "msg": "Could not process your request."
            });
        });
    },
    deleteTimerJob(processId) {
        axios.defaults.withCredentials = true;
        return axios.delete(constants.BASE_URL + "/process-engine/process-definitions-api/" + processId + "/delete-timer-job").then(response => {
            return response.data;
        }).catch(error => {
            EventBus.$emit('warning-notification', {
                "msg": "Could not process your request."
            });
        });
    },
}
